const messages = {
    "actions.confirm": "Confirm",
    main: {
        titles: {
            step1: "Company search",
        },
    },
};

export default messages;
